import light from './light';
import dark from './dark';
import custom from './custom';

export default {
  light,
  dark,
  custom,
};
